export default __webpack_public_path__ + "static/media/Dtac.3bb690c8.png";